export enum ServiceCode {
    BariPost = 'BariPost',
    BariPre = 'BariPre',
    DermaC = 'DermaC',
    DermaCsc = 'DermaCsc',
    DermaCwond = 'DermaCwond',
    DermaOth = 'DermaOth',
    DermaSnelC = 'DermaSnelC',
    DermaSnelCsc = 'DermaSnelCsc',
    Echography = 'Echography',
    GGZBmind = 'GGZBmind',
    GGZBther = 'GGZBther',
    GGZBtherTreat = 'GGZBtherTreat',
    GGZCf2f = 'GGZCf2f',
    GGZCg = 'GGZCg',
    GGZCmdo = 'GGZCmdo',
    GGZCt = 'GGZCt',
    GGZCtriage = 'GGZCtriage',
    GGZOembl = 'GGZOembl',
    GGZOint = 'GGZOint',
    GGZv = 'GGZv',
    GTC = 'GTC',
    GTO = 'GTO',
    Headache = 'Headache',
    HearingLoss = 'HearingLoss',
    Holter = 'Holter',
    LAB = 'LAB',
    LumbarRadiculopathy = 'LumbarRadiculopathy',
    OCRK = 'OCRK',
    OORK = 'OORK',
    OrthC = 'OrthC',
    OrthO = 'OrthO',
    OrthOFol = 'OrthOFol',
    OSAS = 'OSAS',
    OSASC1 = 'OSASC1',
    OSASC2 = 'OSASC2',
    OSASE = 'OSASE',
    OSASEND = 'OSASEND',
    OSASN = 'OSASN',
    OSASO = 'OSASO',
    OSASQ = 'OSASQ',
    OSASV = 'OSASV',
    OSASVC = 'OSASVC',
    OSASVO = 'OSASVO',
    PILOT = 'PILOT',
    RespiAller = 'RespiAller',
    TCCh = 'TCCh',
    TCCi = 'TCCi',
    TCCr = 'TCCr',
    TCOH = 'TCOH',
    TCOR = 'TCOR',
    TFC = 'TFC',
    TFO = 'TFO',
    TIECG = 'TIECG',
    TOC = 'TOC',
    TOO = 'TOO',
    TOV = 'TOV',
    TPC = 'TPC',
    TPCFlex = 'TPCFlex',
    TPO = 'TPO',
    TPOFlex = 'TPOFlex',
}
